export var Locale;
(function (Locale) {
    Locale[Locale["zh_CHS"] = 4] = "zh_CHS";
    Locale[Locale["ar_SA"] = 1025] = "ar_SA";
    Locale[Locale["bg_BG"] = 1026] = "bg_BG";
    Locale[Locale["ca_ES"] = 1027] = "ca_ES";
    Locale[Locale["zh_TW"] = 1028] = "zh_TW";
    Locale[Locale["cs_CZ"] = 1029] = "cs_CZ";
    Locale[Locale["da_DK"] = 1030] = "da_DK";
    Locale[Locale["de_DE"] = 1031] = "de_DE";
    Locale[Locale["el_GR"] = 1032] = "el_GR";
    Locale[Locale["en_US"] = 1033] = "en_US";
    // es_ES = 1034, // Spanish can be one of two LCIDs, but objects can't have duplicate keys :|
    Locale[Locale["fi_FI"] = 1035] = "fi_FI";
    Locale[Locale["fr_FR"] = 1036] = "fr_FR";
    Locale[Locale["he_IL"] = 1037] = "he_IL";
    Locale[Locale["hu_HU"] = 1038] = "hu_HU";
    Locale[Locale["is_IS"] = 1039] = "is_IS";
    Locale[Locale["it_IT"] = 1040] = "it_IT";
    Locale[Locale["ja_JP"] = 1041] = "ja_JP";
    Locale[Locale["ko_KR"] = 1042] = "ko_KR";
    Locale[Locale["nl_NL"] = 1043] = "nl_NL";
    Locale[Locale["nb_NO"] = 1044] = "nb_NO";
    Locale[Locale["pl_PL"] = 1045] = "pl_PL";
    Locale[Locale["pt_BR"] = 1046] = "pt_BR";
    Locale[Locale["rm_CH"] = 1047] = "rm_CH";
    Locale[Locale["ro_RO"] = 1048] = "ro_RO";
    Locale[Locale["ru_RU"] = 1049] = "ru_RU";
    Locale[Locale["hr_HR"] = 1050] = "hr_HR";
    Locale[Locale["sk_SK"] = 1051] = "sk_SK";
    Locale[Locale["sq_AL"] = 1052] = "sq_AL";
    Locale[Locale["sv_SE"] = 1053] = "sv_SE";
    Locale[Locale["th_TH"] = 1054] = "th_TH";
    Locale[Locale["tr_TR"] = 1055] = "tr_TR";
    Locale[Locale["ur_PK"] = 1056] = "ur_PK";
    Locale[Locale["id_ID"] = 1057] = "id_ID";
    Locale[Locale["uk_UA"] = 1058] = "uk_UA";
    Locale[Locale["be_BY"] = 1059] = "be_BY";
    Locale[Locale["sl_SI"] = 1060] = "sl_SI";
    Locale[Locale["et_EE"] = 1061] = "et_EE";
    Locale[Locale["lv_LV"] = 1062] = "lv_LV";
    Locale[Locale["lt_LT"] = 1063] = "lt_LT";
    Locale[Locale["tg_TJ"] = 1064] = "tg_TJ";
    Locale[Locale["fa_IR"] = 1065] = "fa_IR";
    Locale[Locale["vi_VN"] = 1066] = "vi_VN";
    Locale[Locale["hy_AM"] = 1067] = "hy_AM";
    Locale[Locale["eu_ES"] = 1069] = "eu_ES";
    Locale[Locale["wen_DE"] = 1070] = "wen_DE";
    Locale[Locale["mk_MK"] = 1071] = "mk_MK";
    Locale[Locale["tn_ZA"] = 1074] = "tn_ZA";
    Locale[Locale["xh_ZA"] = 1076] = "xh_ZA";
    Locale[Locale["zu_ZA"] = 1077] = "zu_ZA";
    Locale[Locale["af_ZA"] = 1078] = "af_ZA";
    Locale[Locale["ka_GE"] = 1079] = "ka_GE";
    Locale[Locale["fo_FO"] = 1080] = "fo_FO";
    Locale[Locale["hi_IN"] = 1081] = "hi_IN";
    Locale[Locale["mt_MT"] = 1082] = "mt_MT";
    Locale[Locale["se_NO"] = 1083] = "se_NO";
    Locale[Locale["ms_MY"] = 1086] = "ms_MY";
    Locale[Locale["kk_KZ"] = 1087] = "kk_KZ";
    Locale[Locale["ky_KG"] = 1088] = "ky_KG";
    Locale[Locale["sw_KE"] = 1089] = "sw_KE";
    Locale[Locale["tk_TM"] = 1090] = "tk_TM";
    Locale[Locale["tt_RU"] = 1092] = "tt_RU";
    Locale[Locale["bn_IN"] = 1093] = "bn_IN";
    Locale[Locale["pa_IN"] = 1094] = "pa_IN";
    Locale[Locale["gu_IN"] = 1095] = "gu_IN";
    Locale[Locale["or_IN"] = 1096] = "or_IN";
    Locale[Locale["ta_IN"] = 1097] = "ta_IN";
    Locale[Locale["te_IN"] = 1098] = "te_IN";
    Locale[Locale["kn_IN"] = 1099] = "kn_IN";
    Locale[Locale["ml_IN"] = 1100] = "ml_IN";
    Locale[Locale["as_IN"] = 1101] = "as_IN";
    Locale[Locale["mr_IN"] = 1102] = "mr_IN";
    Locale[Locale["sa_IN"] = 1103] = "sa_IN";
    Locale[Locale["mn_MN"] = 1104] = "mn_MN";
    Locale[Locale["bo_CN"] = 1105] = "bo_CN";
    Locale[Locale["cy_GB"] = 1106] = "cy_GB";
    Locale[Locale["kh_KH"] = 1107] = "kh_KH";
    Locale[Locale["lo_LA"] = 1108] = "lo_LA";
    Locale[Locale["my_MM"] = 1109] = "my_MM";
    Locale[Locale["gl_ES"] = 1110] = "gl_ES";
    Locale[Locale["kok_IN"] = 1111] = "kok_IN";
    Locale[Locale["syr_SY"] = 1114] = "syr_SY";
    Locale[Locale["si_LK"] = 1115] = "si_LK";
    Locale[Locale["am_ET"] = 1118] = "am_ET";
    Locale[Locale["ne_NP"] = 1121] = "ne_NP";
    Locale[Locale["fy_NL"] = 1122] = "fy_NL";
    Locale[Locale["ps_AF"] = 1123] = "ps_AF";
    Locale[Locale["fil_PH"] = 1124] = "fil_PH";
    Locale[Locale["div_MV"] = 1125] = "div_MV";
    Locale[Locale["ha_NG"] = 1128] = "ha_NG";
    Locale[Locale["yo_NG"] = 1130] = "yo_NG";
    Locale[Locale["quz_BO"] = 1131] = "quz_BO";
    Locale[Locale["ns_ZA"] = 1132] = "ns_ZA";
    Locale[Locale["ba_RU"] = 1133] = "ba_RU";
    Locale[Locale["lb_LU"] = 1134] = "lb_LU";
    Locale[Locale["kl_GL"] = 1135] = "kl_GL";
    Locale[Locale["ii_CN"] = 1144] = "ii_CN";
    Locale[Locale["arn_CL"] = 1146] = "arn_CL";
    Locale[Locale["moh_CA"] = 1148] = "moh_CA";
    Locale[Locale["br_FR"] = 1150] = "br_FR";
    Locale[Locale["ug_CN"] = 1152] = "ug_CN";
    Locale[Locale["mi_NZ"] = 1153] = "mi_NZ";
    Locale[Locale["oc_FR"] = 1154] = "oc_FR";
    Locale[Locale["co_FR"] = 1155] = "co_FR";
    Locale[Locale["gsw_FR"] = 1156] = "gsw_FR";
    Locale[Locale["sah_RU"] = 1157] = "sah_RU";
    Locale[Locale["qut_GT"] = 1158] = "qut_GT";
    Locale[Locale["rw_RW"] = 1159] = "rw_RW";
    Locale[Locale["wo_SN"] = 1160] = "wo_SN";
    Locale[Locale["gbz_AF"] = 1164] = "gbz_AF";
    Locale[Locale["ar_IQ"] = 2049] = "ar_IQ";
    Locale[Locale["zh_CN"] = 2052] = "zh_CN";
    Locale[Locale["de_CH"] = 2055] = "de_CH";
    Locale[Locale["en_GB"] = 2057] = "en_GB";
    Locale[Locale["es_MX"] = 2058] = "es_MX";
    Locale[Locale["fr_BE"] = 2060] = "fr_BE";
    Locale[Locale["it_CH"] = 2064] = "it_CH";
    Locale[Locale["nl_BE"] = 2067] = "nl_BE";
    Locale[Locale["nn_NO"] = 2068] = "nn_NO";
    Locale[Locale["pt_PT"] = 2070] = "pt_PT";
    Locale[Locale["sv_FI"] = 2077] = "sv_FI";
    Locale[Locale["ur_IN"] = 2080] = "ur_IN";
    Locale[Locale["az_AZ"] = 2092] = "az_AZ";
    Locale[Locale["dsb_DE"] = 2094] = "dsb_DE";
    Locale[Locale["se_SE"] = 2107] = "se_SE";
    Locale[Locale["ga_IE"] = 2108] = "ga_IE";
    Locale[Locale["ms_BN"] = 2110] = "ms_BN";
    Locale[Locale["uz_UZ"] = 2115] = "uz_UZ";
    Locale[Locale["mn_CN"] = 2128] = "mn_CN";
    Locale[Locale["bo_BT"] = 2129] = "bo_BT";
    Locale[Locale["iu_CA"] = 2141] = "iu_CA";
    Locale[Locale["tmz_DZ"] = 2143] = "tmz_DZ";
    Locale[Locale["quz_EC"] = 2155] = "quz_EC";
    Locale[Locale["ar_EG"] = 3073] = "ar_EG";
    Locale[Locale["zh_HK"] = 3076] = "zh_HK";
    Locale[Locale["de_AT"] = 3079] = "de_AT";
    Locale[Locale["en_AU"] = 3081] = "en_AU";
    Locale[Locale["es_ES"] = 3082] = "es_ES";
    Locale[Locale["fr_CA"] = 3084] = "fr_CA";
    Locale[Locale["sr_SP"] = 3098] = "sr_SP";
    Locale[Locale["se_FI"] = 3131] = "se_FI";
    Locale[Locale["quz_PE"] = 3179] = "quz_PE";
    Locale[Locale["ar_LY"] = 4097] = "ar_LY";
    Locale[Locale["zh_SG"] = 4100] = "zh_SG";
    Locale[Locale["de_LU"] = 4103] = "de_LU";
    Locale[Locale["en_CA"] = 4105] = "en_CA";
    Locale[Locale["es_GT"] = 4106] = "es_GT";
    Locale[Locale["fr_CH"] = 4108] = "fr_CH";
    Locale[Locale["hr_BA"] = 4122] = "hr_BA";
    Locale[Locale["smj_NO"] = 4155] = "smj_NO";
    Locale[Locale["ar_DZ"] = 5121] = "ar_DZ";
    Locale[Locale["zh_MO"] = 5124] = "zh_MO";
    Locale[Locale["de_LI"] = 5127] = "de_LI";
    Locale[Locale["en_NZ"] = 5129] = "en_NZ";
    Locale[Locale["es_CR"] = 5130] = "es_CR";
    Locale[Locale["fr_LU"] = 5132] = "fr_LU";
    Locale[Locale["smj_SE"] = 5179] = "smj_SE";
    Locale[Locale["ar_MA"] = 6145] = "ar_MA";
    Locale[Locale["en_IE"] = 6153] = "en_IE";
    Locale[Locale["es_PA"] = 6154] = "es_PA";
    Locale[Locale["fr_MC"] = 6156] = "fr_MC";
    Locale[Locale["sma_NO"] = 6203] = "sma_NO";
    Locale[Locale["ar_TN"] = 7169] = "ar_TN";
    Locale[Locale["en_ZA"] = 7177] = "en_ZA";
    Locale[Locale["es_DO"] = 7178] = "es_DO";
    Locale[Locale["sr_BA"] = 7194] = "sr_BA";
    Locale[Locale["sma_SE"] = 7227] = "sma_SE";
    Locale[Locale["ar_OM"] = 8193] = "ar_OM";
    Locale[Locale["en_JA"] = 8201] = "en_JA";
    Locale[Locale["es_VE"] = 8202] = "es_VE";
    Locale[Locale["bs_BA"] = 8218] = "bs_BA";
    Locale[Locale["sms_FI"] = 8251] = "sms_FI";
    Locale[Locale["ar_YE"] = 9217] = "ar_YE";
    Locale[Locale["en_CB"] = 9225] = "en_CB";
    Locale[Locale["es_CO"] = 9226] = "es_CO";
    Locale[Locale["smn_FI"] = 9275] = "smn_FI";
    Locale[Locale["ar_SY"] = 10241] = "ar_SY";
    Locale[Locale["en_BZ"] = 10249] = "en_BZ";
    Locale[Locale["es_PE"] = 10250] = "es_PE";
    Locale[Locale["ar_JO"] = 11265] = "ar_JO";
    Locale[Locale["en_TT"] = 11273] = "en_TT";
    Locale[Locale["es_AR"] = 11274] = "es_AR";
    Locale[Locale["ar_LB"] = 12289] = "ar_LB";
    Locale[Locale["en_ZW"] = 12297] = "en_ZW";
    Locale[Locale["es_EC"] = 12298] = "es_EC";
    Locale[Locale["ar_KW"] = 13313] = "ar_KW";
    Locale[Locale["en_PH"] = 13321] = "en_PH";
    Locale[Locale["es_CL"] = 13322] = "es_CL";
    Locale[Locale["ar_AE"] = 14337] = "ar_AE";
    Locale[Locale["es_UR"] = 14346] = "es_UR";
    Locale[Locale["ar_BH"] = 15361] = "ar_BH";
    Locale[Locale["es_PY"] = 15370] = "es_PY";
    Locale[Locale["ar_QA"] = 16385] = "ar_QA";
    Locale[Locale["es_BO"] = 16394] = "es_BO";
    Locale[Locale["en_MY"] = 17417] = "en_MY";
    Locale[Locale["es_SV"] = 17418] = "es_SV";
    Locale[Locale["en_IN"] = 18441] = "en_IN";
    Locale[Locale["es_HN"] = 18442] = "es_HN";
    Locale[Locale["es_NI"] = 19466] = "es_NI";
    Locale[Locale["es_PR"] = 20490] = "es_PR";
    Locale[Locale["es_US"] = 21514] = "es_US";
    Locale[Locale["zh_CHT"] = 31748] = "zh_CHT";
})(Locale || (Locale = {}));
